<template>
  <div class="p-2 sm:p-5">
    <div class="container mx-auto max-w-6xl">
      <div class="flex flex-col lg:flex-row">
        <div class="bg-white rounded-lg shadow-card p-4 sm:p-12 mb-5 lg:mr-5 w-full self-start select-none">
          <h1 class="font-semibold text-2xl lg:text-3xl">
            {{ message ? 'Edit Message' : 'Add New Message' }}
          </h1>
          <section class="mt-5">
            <form @submit="submit">
              <fieldset>
                <label for="target">Target Characters<small>*</small></label>
                <select id="target" v-model="messageTarget" class="input mt-2" name="target">
                  <option value="all_attendees">All Attendees</option>
                  <option v-for="character in characters" :key="character.id"
                          :disabled="form.trigger_type === 'enrollment_start'"
                          :value="character.id">
                    {{ character.name }}
                  </option>
                </select>
              </fieldset>
              <fieldset class="mt-4">
                <label for="name">Name<small>*</small></label>
                <input id="name" v-model="form.name" class="input mt-2" required type="text"/>
              </fieldset>
              <fieldset class="mt-4">
                <label for="description">Description<small>*</small></label>
                <textarea id="description" v-model="form.description" class="textarea mt-2" required/>
              </fieldset>
              <fieldset class="mt-4">
                <label for="subject">Email Subject<small>*</small></label>
                <input id="subject" v-model="form.subject" class="input mt-2" required type="text"/>
              </fieldset>
              <fieldset class="mt-4">
                <label>Message<small>*</small></label>
                <VueEditor v-model="form.message" class="mt-2"/>
              </fieldset>

              <div class="mt-12 font-semibold">
                <label class="inline-flex items-center">
                  <checkbox :value="form.copy_team_members" @change="value => { form.copy_team_members = value }"/>
                  <span class="ml-2">Copy to all  team members</span>
                </label>
              </div>

              <div class="mt-12 font-semibold">
                <label class="inline-flex items-center">
                  <input v-model="whenSend" class="form-radio w-6 h-6 text-primary" name="when_send" type="radio"
                         value="trigger">
                  <span class="ml-2">When does this need to be sent?</span>
                </label>
              </div>
              <div :class="whenSend !== 'trigger' ? 'opacity-25 pointer-events-none' :''"
                   class="mt-4 flex flex-col md:flex-row">
                <div>
                  <div class="mb-2">Delay</div>
                  <label class="inline-flex items-center w-full md:w-auto">
                    <span class="mr-2">Wait</span>
                    <input id="delay" v-model="delayNumber" class="input md:w-24 text-center" required
                           type="number"/>
                    <select v-model="delayFormat" class="input" required>
                      <option value="d">day</option>
                      <option value="h">hour</option>
                      <option value="m">minute</option>
                    </select>
                  </label>
                  <label class="block md:inline-flex mt-3 md:mt-0 md:ml-3">
                    <select v-model="form.delay_type" class="input">
                      <option
                          :disabled="form.trigger_type === 'enrollment_start' || form.trigger_type === 'attendee_submits_order' || form.trigger_type === 'attendee_picks_item'"
                          value="before">
                        before
                      </option>
                      <option value="after">after</option>
                    </select>
                  </label>
                </div>
                <div class="flex-1 mt-3 md:mt-0 md:ml-3">
                  <div class="mb-2">Trigger</div>
                  <label class="block">
                    <select v-model="form.trigger_type" class="input" name="trigger">
                      <option value="event_start">Event Start</option>
                      <option value="enrollment_start">Attendee Enroll</option>
                      <option value="attendee_submits_order">Attendee Submits Order</option>
                      <option value="attendee_picks_item">Attendee Picks Item</option>
                    </select>
                  </label>
                </div>
              </div>

              <div v-if="form.trigger_type === 'attendee_picks_item'" class="mt-6">
                <div class="mb-2">Select items</div>
                <Multiselect
                    v-model="selectedItems"
                    :multiple="true"
                    :options="categories"
                    group-label="name"
                    group-values="items"
                    label="name"
                    track-by="id"
                ></Multiselect>
              </div>

              <div class="mt-12 font-semibold">
                <label class="inline-flex items-center">
                  <input v-model="whenSend" class="form-radio w-6 h-6 text-primary" name="when_send" type="radio"
                         value="date">
                  <span class="ml-2">Or select a specific date and time</span>
                </label>
              </div>
              <div :class="whenSend !== 'date' ? 'opacity-25 pointer-events-none' :''"
                   class="mt-4 flex flex-col md:flex-row">
                <fieldset class="flex-1">
                  <label>Date</label>
                  <datepicker :disabled-dates="{to: new Date()}" :value="form.sendDate" class="mt-2"
                              @selected="form.sendDate = $event"></datepicker>
                </fieldset>
                <fieldset class="flex-1 mt-4 md:mt-0 ml-0 md:ml-4">
                  <label>Time</label>
                  <vue-timepicker v-model="form.sendTime" class="mt-2"></vue-timepicker>
                </fieldset>
              </div>
              <div class="flex flex-col-reverse sm:flex-row justify-between mt-16">
                <button
                    class="btn btn-secondary font-semibold rounded px-10 min-w-10 mt-5 sm:mt-0"
                    @click="$router.back()"
                >
                  <span>Cancel</span>
                </button>
                <button
                    :disabled="!canSubmit"
                    class="btn btn-primary font-semibold rounded px-10 min-w-10"
                    type="submit"
                >
                  <span v-if="!progressSaving">Save Message</span>
                  <Spinner v-if="progressSaving" class="mx-auto"/>
                </button>
              </div>
            </form>
          </section>
        </div>
        <div class="bg-white rounded-lg shadow-card p-4 sm:p-8 lg:max-w-sm w-full self-start">
          <img alt="BuildaBox Order Edit Page" class="mb-4 " height="32" src="@/assets/icons/info.svg" width="32">
          <div class="mb-3">
            <h1 class="font-semibold text-lg">Helper Info Box</h1>
          </div>
          <p class="pb-10">
            Specific messages are configured on this page.
            <br/><br/>
            Name & Description: This is used by event organizers to identify the message and will not be visible to
            attendees or box recipients.
            <br/><br/>
            Email Subject: This is the email subject that the attendee will see.
            <br/><br/>
            Message: This is the email message body.
            <br/><br/>
            When Does this Need to Be Sent: Enter a conditional rule here if you want this email to be sent at a time
            relative to the previous email or an event milestone, such as the start and end dates.
            <br/><br/>
            Or Select a Specific date and Time: Enter a specific date and time to send the email here if you do not want
            the message to be sent based on the previous email.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'
import { VueEditor } from 'vue2-editor'
import Datepicker from '@/third-party/vuejs-datepicker/src/components/Datepicker'
import VueTimepicker from '@/third-party/vue2-timepicker/src/vue-timepicker'
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
import Api from '@/api/api_v1.0'
import Checkbox from '@/components/common/controls/Checkbox.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Datepicker,
    Spinner,
    VueEditor,
    VueTimepicker,
    Checkbox,
    Multiselect
  },
  props     : {
    orderUuid : String,
    characters: Array,
    categories: Array,
    message   : Object
  },
  data () {
    return {
      whenSend      : 'trigger',
      form          : {
        id               : '',
        target_type      : 'all_attendees',
        target_value     : '',
        name             : '',
        description      : '',
        subject          : '',
        message          : '',
        sendDate         : null,
        sendTime         : '',
        send_at          : '',
        delay_type       : 'before',
        delay_value      : 0,
        trigger_type     : 'event_start',
        copy_team_members: false,
        order_items      : []
      },
      delayNumber   : 0,
      delayFormat   : 'd',
      progressSaving: false,
    }
  },
  computed   : {
    messageTarget: {
      get () {
        console.log(this.form.target_type)
        if (this.form.target_type === 'characters') {
          return this.form.target_value
        } else {
          return 'all_attendees'
        }
      },
      set (value) {
        console.log(value)
        if (value === 'all_attendees') {
          this.form.target_type = 'all_attendees'
          this.form.target_value = ''
        } else {
          this.form.target_type = 'characters'
          this.form.target_value = value
        }
      }
    },
    selectedItems: {
      get () {
        const items = []

        this.categories.forEach(category => {
          category.items.forEach(item => items.push(item))
        })

        return items.filter(
            item => this.form.order_items.includes(item.id)
        )
      },
      set (items) {
        this.form.order_items = items.map(item => item.id)
      }
    },
    canSubmit () {
      return !this.$v.$invalid
    }
  },
  watch      : {
    'form.trigger_type': function (newVal) {
      if (newVal === 'enrollment_start' || newVal === 'attendee_submits_order') {
        this.form.delay_type = 'after'
        // this.form.target_type = 'all_attendees'
      }
      if (newVal === 'attendee_picks_item') {
        this.form.delay_type = 'after'
      }
    }
  },
  validations: {
    form       : {
      target_type : { required },
      target_value: {
        required: requiredIf(function () {
          return this.form.target_type === 'characters'
        })
      },
      name        : { required },
      description : { required },
      subject     : { required },
      message     : { required },
      sendDate    : {
        required: requiredIf(function () {
          return this.whenSend === 'date'
        })
      },
      sendTime    : {
        required: requiredIf(function () {
          return this.whenSend === 'date'
        })
      },
      delay_type  : {
        required: requiredIf(function () {
          return this.whenSend === 'trigger'
        })
      },
      trigger_type: {
        required: requiredIf(function () {
          return this.whenSend === 'trigger'
        })
      }
    },
    delayNumber: {
      required: requiredIf(function () {
        return this.whenSend === 'trigger'
      })
    },
    delayFormat: {
      required: requiredIf(function () {
        return this.whenSend === 'trigger'
      })
    }
  },
  created () {
    if (this.message) {
      this.form.id = this.message.id
      this.form.target_type = this.message.target_type
      this.form.target_value = this.message.target_value
      this.form.name = this.message.name
      this.form.description = this.message.description
      this.form.subject = this.message.subject
      this.form.message = this.message.message
      this.form.delay_type = this.message.delay_type
      this.form.delay_value = this.message.delay_value
      this.form.trigger_type = this.message.trigger_type
      this.form.send_at = this.message.send_at
      this.form.copy_team_members = this.message.copy_team_members
      this.form.order_items = this.message.order_items
    }

    if (this.form.send_at) {
      const sendDate = moment.utc(this.form.send_at)
      this.form.sendDate = sendDate.toDate()
      this.form.sendTime = sendDate.format('HH:mm')
      this.whenSend = 'date'
    } else {
      this.form.sendDate = null
      this.form.sendTime = ''
      this.whenSend = 'trigger'
    }

    if (this.form.delay_value) {
      const delay = parseInt(this.form.delay_value)
      if (delay % (60 * 24) === 0) {
        this.delayNumber = delay / (60 * 24)
        this.delayFormat = 'd'
      } else if (delay % 60 === 0) {
        this.delayNumber = delay / 60
        this.delayFormat = 'h'
      } else {
        this.delayNumber = delay
        this.delayFormat = 'm'
      }
    } else {
      this.delayNumber = 0
      this.delayFormat = 'h'
    }

    this.form.notrim = Math.random(8).toString()
  },
  methods: {
    onSelectCopyTeamMembers (value) {
      console.log(value)
    },

    submit (event) {
      event.preventDefault()
      if (this.whenSend === 'date') {
        let dateString = `${moment(this.form.sendDate).format('YYYY-MM-DD')} ${this.form.sendTime}`
        const sendDate = moment.utc(dateString).toDate()
        if (sendDate < new Date()) {
          this.showGlobalErrorMessage('Send date should be after the current date.')
          return
        }
        this.form.send_at = dateString
        this.form.delay_type = null
        this.form.delay_value = null
        this.form.trigger_type = null
      } else {
        if (!this.form.trigger_type || !this.form.delay_type) {
          this.showGlobalErrorMessage('Please select before/after and trigger action.')
          return
        }
        if (this.delayFormat === 'd') {
          this.form.delay_value = this.delayNumber * 60 * 24
        } else if (this.delayFormat === 'h') {
          this.form.delay_value = this.delayNumber * 60
        } else {
          this.form.delay_value = this.delayNumber
        }
        this.form.send_at = ''
      }

      // Save message details.
      this.progressSaving = true
      Api.saveMessageForOrder(this.orderUuid, this.form).then(() => {
        this.progressSaving = false
        this.$emit('submit')
      }).catch(() => {
        this.progressSaving = false
      })
    }
  }
}
</script>


<style>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.multiselect {
  color: initial;
}

.multiselect__tags {
  background: white;
  border: 1px solid #e0e2e9;
  border-radius: 8px;
  padding: 11px 1rem 0 1rem;
  font-size: initial;
  min-height: 50px;
}

.multiselect__select {
  height: 50px;
}

.multiselect__input,
.multiselect__single {
  margin: 0;
  padding: 0;
  min-height: auto;
}

.multiselect__placeholder {
  margin-bottom: 0;
  padding-top: 0;
  line-height: 1;
  vertical-align: middle;
}

.multiselect__input,
.multiselect__single {
  line-height: 1;
  vertical-align: middle;
}

.multiselect__content-wrapper {
  border-color: #e0e2e9;
}

.multiselect__tag {
  background-color: #f75f39;
}

.multiselect__tag-icon:after {
  color: white;
}
</style>
